export default __webpack_public_path__ + "static/media/field.816dfe9c.svg";